<template>
  <div>
    <ion-grid>
      <ion-row>
        <ion-col>
          <vueSignature
            ref="signature"
            :sigOption="option"
            :w="'100%'"
            :h="'225px'"
            :clearOnResize="true"></vueSignature>
        </ion-col>
      </ion-row>
    </ion-grid>
    <ion-grid>
      <ion-row>
        <ion-col>
          <ion-button
            color="primary"
            expand="block"
            fill="outline"
            size="small"
            v-on:click="saveSignature">
            <ion-icon slot="start" color="primary" ios="ios-save" md="md-save" /> Save
          </ion-button>
        </ion-col>
        <ion-col>
          <ion-button
            color="danger"
            expand="block"
            fill="outline"
            size="small"
            v-on:click="clearSignature">
            <ion-icon slot="start" color="danger" ios="ios-trash" md="md-trash" /> Clear
          </ion-button>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</template>

<script>
import Field from "../models/Field";
import Value from "../models/Value";
export default {
  name: "field-signature",
  components: {},
  props: ["field", "value"],
  data() {
    return {
      option: {
        penColor: "rgb(0,0,0)",
        backgroundColor: "rgb(246,246,246)"
      }
    };
  },
  mounted() {
      setTimeout(() => {
          this.loadSignature();
          this.clearSignature();
      }, 1000);
  },
  methods: {
    loadSignature() {
      let canvas = document.querySelector("canvas");
      let ratio = Math.max(window.devicePixelRatio || 1, 1);
      canvas.width = canvas.offsetWidth * ratio;
      canvas.height = canvas.offsetHeight * ratio;
      canvas.getContext("2d").scale(ratio, ratio);
    },
    saveSignature() {
      var jpeg = this.$refs.signature.save("image/jpeg");
      this.value.value = jpeg;
    },
    clearSignature() {
      this.$refs.signature.clear();
      this.value.value = "";
    }
  }
};
</script>

<style scoped>
</style>